var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRBorrar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.18 31.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__cls-2{fill:#464646;stroke:#fff;stroke-width:.1px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__base-55",
    fill: "none",
    d: "M0 0h31.18v31.18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__Trazado_2707-2",
    "data-name": "Trazado 2707-2",
    className: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__cls-2",
    d: "M20.84 7.82h-3.38v-.48A1.45 1.45 0 0016 5.89h-1.92a1.45 1.45 0 00-1.45 1.45v.48H9.25A1.44 1.44 0 007.8 9.27v1a1.43 1.43 0 001 1.36v12.13a1.44 1.44 0 001.45 1.45h9.67a1.44 1.44 0 001.45-1.45V11.6a1.43 1.43 0 001-1.36v-1a1.45 1.45 0 00-1.45-1.45zm-7.25-.48a.48.48 0 01.49-.48H16a.47.47 0 01.48.48v.48h-2.9zm6.28 16.91h-9.66a.49.49 0 01-.49-.49V11.69h10.63v12.07a.49.49 0 01-.48.49zm1.45-14a.48.48 0 01-.48.48H9.25a.49.49 0 01-.49-.48v-1a.48.48 0 01.49-.48h11.59a.47.47 0 01.48.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__Trazado_2708-2",
    "data-name": "Trazado 2708-2",
    className: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__cls-2",
    d: "M17.94 13.62a.44.44 0 00-.48.39v7.87a.49.49 0 00.58.39.48.48 0 00.38-.39V14a.44.44 0 00-.48-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__Trazado_2709-2",
    "data-name": "Trazado 2709-2",
    className: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__cls-2",
    d: "M15 13.62a.44.44 0 00-.48.39v7.87a.49.49 0 00.58.39.5.5 0 00.39-.39V14a.45.45 0 00-.49-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__Trazado_2710-2",
    "data-name": "Trazado 2710-2",
    className: "R-Borrar_svg__R-Borrar_svg__R-Borrar_svg__cls-2",
    d: "M12.14 13.62a.44.44 0 00-.48.39v7.87a.49.49 0 00.58.39.5.5 0 00.39-.39V14a.45.45 0 00-.49-.38z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRBorrar);
export default __webpack_public_path__ + "static/media/R-Borrar.09106678.svg";
export { ForwardRef as ReactComponent };